import React, { useEffect } from "react";
import SideBar from "../components/sidebar";
import placeholder from "../img/placeholder.png";
import upArrow from "../img/uparrow.svg";
import downArrow from "../img/downarrow.svg";
import aicomparison from "../img/AIcomparison.png";
import drivercomparison from "../img/drivercomparison.png";
import DriverColours, { DriversInitials } from "../components/driverColours";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const Dashboard = ({ showSidebar, isPremium, setPage }) => {
  const naviagte = useNavigate();
  const [isPreviousGF, setIsPreviousGF] = useState(false);
  const [isPreviousLTC, setIsPreviousLTC] = useState(false);

  useEffect(() => {
    // Check if user has had previous calls
    fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/coach/get-previous-calls?UserID=${
        JSON.parse(localStorage.getItem("sb_id")).id
      }&figureName=${"gear-figure"}&figureName2=${"lap-time-comparison"}`,
      {
        method: "GET",
      }
    )
      .then((res) => res.json())
      .then((res) => {
        for (let figure = 0; figure < res.message.length; figure++) {
          const element = res.message[figure];

          if (element.gearFigure) {
            setIsPreviousGF(true);
          } else if (element.lapTimeComparison) {
            setIsPreviousLTC(true);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  });

  // Dynamically setting text dependent on if the user has used the tool before/ if they have premium
  const setText = () => {
    return {
      "upload-lap": isPreviousGF ? "Your Previous Figures" : "Create a figure",
      "upload-button": isPreviousGF
        ? "Upload another lap here"
        : "Upload a lap",
      "compare-lap": isPreviousLTC
        ? "Your last lap comparison"
        : "Start comparing drivers",
      "compare-button": isPreviousLTC
        ? "Compare more laps here"
        : "Make a lap comparison",
      "ai-coach-button": isPremium
        ? "Develop another insight"
        : "Begin enhancing your analysis",
    };
  };

  // Eventually do an API call to check if the user has previously used any tools - potentially change isPrevious

  return (
    <div className="dashboard-container">
      {showSidebar && <SideBar setPage={setPage} />}

      <div className="dashboard-content">
        <div className="top-row-dash">
          <div className="upload-lap-container">
            <div className="upload-lap-header">{setText()["upload-lap"]}</div>

            <div className="previous-lap">
              <img src={aicomparison} />
            </div>

            <button
              className="lap-button"
              onClick={() => {
                naviagte("/gear-figure");
                setPage("gear-figure");
              }}
            >
              {setText()["upload-button"]}
            </button>
          </div>

          <div className="compare-lap-container">
            <div className="compare-lap-header">{setText()["compare-lap"]}</div>

            <div className="previous-comparison">
              <img src={placeholder} />
            </div>

            <button
              className="lap-button"
              onClick={() => {
                naviagte("/lap-time-comparison");
                setPage("lap-time-comparison");
              }}
            >
              {setText()["compare-button"]}
            </button>
          </div>
        </div>

        <div className="ai-card-container">
          <div className="ai-card-header">Your AI analysis</div>

          <div className="ai-card-content">
            <ul className="ai-card-suggestions">
              <li>
                <img src={upArrow} />"
                <span style={{ color: DriverColours[0] }}>
                  {DriversInitials[0]}
                </span>
                {""}
                <span style={{ color: "green" }}>gained 0.2 seconds</span> by
                braking 20m later in turn 8"
              </li>
              <li>
                <img src={downArrow} />"
                <span style={{ color: DriverColours[18] }}>
                  {DriversInitials[18]}
                </span>{" "}
                <span style={{ color: "red" }}>lost 0.32 seconds</span> because
                of taking turn 13 in 5th gear"
              </li>
            </ul>

            <div className="ai-comparison">
              <img src={drivercomparison} />
            </div>

            <button
              className="ai-coach-button"
              onClick={() => {
                naviagte("/ai-coach");
                setPage("ai-coach");
              }}
            >
              {setText()["ai-coach-button"]}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
